import CustomBox from './CustomBox';

interface DetailsHeaderProps {
    label: string;
}

function DetailsHeader({ label }: DetailsHeaderProps) {
    return (
        <CustomBox>
            <h4 className="text-foreground text-xl font-bold">{label}</h4>
        </CustomBox>
    );
}

export default DetailsHeader;
